import * as angular from "angular";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";

angular
  .module('bringoz.admin.resources')
  .factory('$agentResource', agentResourceObjectFactory);

function agentResourceObjectFactory($bringozFactory: $bringozFactory,
                                    ResourcesAPI: BringozApi,
                                    AgentResourceBindings_DS: DataStoreConfig) {

  function $agentResource(id: string) {
    return $bringozFactory(id, ResourcesAPI, AgentResourceBindings_DS)
  }

  return $agentResource
}
